import Vue from 'vue';
import Main from './main.vue';
let ConfirmConstructor = Vue.extend(Main);
const instance = new ConfirmConstructor().$mount();
let init = false;
let defaultOptions = {
  yesBtnText: '确定',
  cancelBtnText: '取消'
};

const confirm = function (options) {
  Object.assign(instance, defaultOptions, options);

  if (!init) {
    document.body.appendChild(instance.$el);
    init = true;
  }

  return instance.confirm();
};

export default confirm;